import { Error404 } from '@cambridgeassessment/cambridge-ui/';
import React from 'react';
import { useNotFoundPageStyles } from './styles';

const NotFoundPage: React.FC = () => {
  const classes = useNotFoundPageStyles();
  return (
    <Error404
      supportUrl={'/contact-us'}
      homepageUrl={'/'}
      className={classes.error404}
    />
  );
};

export default NotFoundPage;
